import { Header } from '@business/workflows/ComponentUI/Header/Header';
import { Sidebar } from '@business/workflows/ComponentUI/Sidebar';
import { MediaUploadPersister } from '@business/workflows/ComponentViews/Photos';
import { getFirstLogin } from '@ports/common/authStateSlice';
import { FC, ReactNode } from 'react';
import { useSelector } from 'react-redux';

interface BaseAppLayoutProps {
  children?: ReactNode;
}

export const BaseAppLayout: FC<BaseAppLayoutProps> = ({ children }) => {
  const isFirstLogin = useSelector(getFirstLogin);
  return (
    <div className="h-screen flex overflow-hidden bg-gray-50 relative">
      {!isFirstLogin && <Sidebar />}
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header />
        <main className="flex-1 overflow-y-auto bg-white">
          <div
            className={`mx-auto px-4 sm:px-6 lg:px-8 py-4 2xl:py-6 ${isFirstLogin ? 'max-w-7xl' : 'max-w-full'}`}>
            {children}
          </div>
          <MediaUploadPersister />
        </main>
      </div>
    </div>
  );
};
